<template lang="pug">
  .info
    .mask.bg-modal.fixed.top-0.right-0.bottom-0.left-0.z-400.w-screen.h-screen(v-if="infoIsShow")
    //@click="onClose()"
    .absolute.right-20.top-52.z-400.w-full(class="xl:right-0" v-if="infoIsShow")
      .flex.justify-end.max-w-1366.m-auto
        .bg-white.shadow-lg.rounded-8.w-260.text-black(v-click-outside="onClose")
          //- .m-auto.z-300.bg-white.shadow-lg.rounded-8.w-260.text-black
          .p-20.text-center
            .mb-16
              p.text-gray-800.font-medium.belong.wordDot() {{$store.state.user.user.company_lname}}
            template.h-72()
              .text-main-0.text-20.text-500.break-all 
                span(v-if="$store.state.user.user.first_name") {{$store.state.user.user.first_name}}  
                span(v-if="$store.state.user.user.last_name") {{$store.state.user.user.last_name}}
              .mb-40 {{$store.state.user.user.email}}
            div
              Button.mb-20( @buttonClick="userCenter()" :text="$t('__userData.__userCenter')")
              Button( @buttonClick="logoutModal()" :text="$t('__userData.__logout')" type="cancel")
    Modal.z-600(
        :show="showModal && !noAlert " 
        :clickOutSideClose="false" 
        @closeModal="modalClose" 
        :header="'header'"
        :body="'footerBody'" 
        footer="footer"  
        )
        template(#footerBody)
          ModalAlert.w-412.mb-20(:data="modalContent" :picWidth="'96'" :align="true"  fontSize="20" custom="checkBox")
            template(#checkBox)
              Checkbox.mt-20(:options="checkOptions" displayColumn="h" :value="check" @changeValue="isCheck")
        template(#footer)
          .flex.justify-center
            Button.mt-10.w-140.mr-20(:text="$t('__globeButton.__cancel')" type="cancel"  @buttonClick='modalClose()')
            Button.mt-10.w-140(:text="$t('__globeButton.__continue')" type="Send"  @buttonClick='logout()')
</template>

<script>
import Button from "@/components/Button.vue";
import Modal from "@/components/Modal.vue";
import ModalAlert from "@/components/ModalAlert.vue";
import Checkbox from "@/components/Checkbox.vue";

import { mapGetters } from "vuex";

import { logout } from "@/api/users.js";

export default {
  name: "User",
  props: {
    show: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  components: {
    Button,
    Modal,
    ModalAlert,
    Checkbox
  },

  data() {
    return {
      showModal: false,

      check: [],
      infoIsShow: false,
      noAlert: false,
      noAsk: false
    };
  },
  computed: {
    ...mapGetters({
      getLogoutLink: "setting/getLogoutLink",
      getBaseLink: "setting/getBaseLink",
      getPAUserCenterLink: "setting/getPAUserCenterLink"
    }),
    modalContent() {
      return {
        //default 搜尋區塊 提示組圖
        title: this.$t("__popUpRelated.__logOutAllService"),
        content: this.$t("__popUpRelated.__youWillLogOutFromAllServiceDoYouStillWantToLogOut"),
        pic: "Alert"
      };
    },
    checkOptions() {
      return [
        {
          name: this.$t("__popUpRelated.__donTShowThisMessageAgain"),
          val: "check",
          disabled: false
        }
      ];
    }
  },
  mounted() {
    // console.log(localStorage.getItem('noLogoutAlert'),'on mount')
    let storage = localStorage.getItem("noLogoutAlert");
    this.noAlert = storage ? (storage == "false" ? false : true) : false;
    this.noAsk = this.noAlert;
    this.check = this.noAlert ? ["check"] : [];
    // console.log(this.$store.state.common.categories,'tgjjigei')
  },
  methods: {
    isCheck(v) {
      this.check = v;
    },
    logoutModal() {
      this.onClose();
      this.showModal = true;
      if (this.noAlert) {
        this.logout();
      }
    },
    userCenter() {
      this.onClose();
      window.open(this.getPAUserCenterLink);
      // this.$emit('userCenter')
      // localStorage.setItem('userId', this.$store.state.user.userData.userid);
    },
    async logout() {
      try {
        await logout();
        localStorage.setItem("noLogoutAlert", this.noAsk);
        this.modalClose();
        window.location = this.getLogoutLink;
      } catch (error) {
        console.log(error);
      }
    },
    modalClose() {
      this.showModal = false;
      this.check = [];
    },
    onClose() {
      this.infoIsShow = false;
      this.$emit("closeUser", false);
    }
  },
  watch: {
    show: {
      handler: function(n) {
        this.infoIsShow = n;
      }
    },
    check: {
      handler: function(n) {
        this.noAsk = n.length ? true : false;
      },
      deep: true
    }
  }
};
</script>
